import { Col, Row, Card } from 'react-bootstrap';
import googleLogo from 'assets/img/landing/google.png';

const reseñasClientes = [
  {
    name: 'Leila Monico',
    text: 'La atención y el asesoramiento fue excelente!! Desde el primer día cuando me acerque al estudio por mi caso me aclararon todas las dudas que tenía sobre cuáles eran mis posibilidades, la información fue clara y el acompañamiento a lo largo de todo el proceso dio por resultado que el caso se resolviera en mi favor! Realmente muy recomendable!'
  },
  {
    name: 'Leandro Xavier Palavecino',
    text: 'La verdad sin palabras en la forma que llevaron a cabo mi situación y como llegaron a solucionar en tan corto tiempo. Muy atentos en todo y muy bien la atención a la hora de explicarme ciertos puntos. Los recomiendo son excelentes personas y profesionales. Muchísimas gracias.'
  },
  {
    name: 'Macarena B.M',
    text: 'Muy buena atención de cada Dr del estudio, de las secretarias... Muy profesionales todos, muy amables, y con mucha paciencia! Muy HONESTOS!!! Los mejores!! Los recomiendo! Muchas gracias estudio Parkes!!'
  }
];

const Testimonial = () => {
  return (
    <section className="py-10 bg-body" id="testimonios">
      <div className="container-small px-lg-7 px-xxl-3 text-center">
        <img src={googleLogo} alt="Google Reviews" className="mb-3" style={{ height: '40px' }} />
        <h2 className="mb-6">Opiniones de nuestros clientes</h2>
        
        <Row className="g-4 text-start">
          {reseñasClientes.map((item, idx) => (
            <Col key={idx} xs={12} lg={4}>
              <Card className="h-100 border border-translucent shadow-sm">
                <Card.Body className="p-4">
                  <h5 className="fw-bold mb-1">{item.name}</h5>
                  <div className="text-warning mb-3">
                    {'★'.repeat(5)}
                  </div>
                  <p className="text-body-secondary fs-9 mb-0">"{item.text}"</p>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
        
        <div className="mt-5">
          <a href="https://maps.app.goo.gl/9akbaaUMnDQVM7SN9" className="btn btn-link fw-bold" target="_blank" rel="noreferrer">
            Ver más opiniones
          </a>
        </div>
      </div>
    </section>
  );
};

export default Testimonial;